module.exports = __webpack_public_path__ + "img/pr-2.67234d0e.png";